/* eslint-disable */
/* eslint-disable react/forbid-prop-types */
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Redirect } from 'react-router-dom'
import queryString from 'query-string'
import { Snackbar } from '@minha-biblioteca/saraiva-ui'
import jwtDecode from 'jwt-decode'
import Bugsnag from '@bugsnag/js'
import Loading from '../../../components/Loading/index.js'
import services from '../../../services'
import { setSessionToken, setSessionStorage } from '../../../auth'
// import { BooksContext } from '../../../contexts/BooksContext.js'
import { LibraryContext } from '../../../contexts/LibraryContext'

export default function JwtAuthentication() {
  const [authenticated, setAuthenticated] = useState(false)
  const [showError, setShowError] = useState(false)
  const { libraryCode, setLibraryCode } = useContext(LibraryContext)

  const fetchData = useCallback(async () => {
    try {
      const parsed = queryString.parse(window.location.search)

      if (!parsed.token || typeof parsed.token !== 'string' || parsed.token.split('.').length !== 3) {
        throw new Error('Invalid or missing JWT token')
      }

      const response = await services.Sessions.loginByJwt(
        parsed.client_name,
        parsed.token
      )

      let decode
      try {
        decode = jwtDecode(parsed.token)
      } catch (err) {
        throw new Error(`Failed to decode token: ${err.message}`)
      }

      if (!response || typeof response.json !== 'function' || !response.ok) {
        setShowError(true)
        localStorage.removeItem('sessionToken')
        return
      }
      let result
      try {
        result = await response.json()
      } catch (e) {
        setShowError(true)
        localStorage.removeItem('sessionToken')
        return
      }

      setAuthenticationDataAndUpdateState(result)
      setLibraryCode(false)

      services.Trackings.integrationLogin()
    } catch (err) {
      Bugsnag.notify(err instanceof Error ? err : new Error(JSON.stringify(err)));
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [])

  function setAuthenticationDataAndUpdateState(
    { tokens: { local_token } },
    useSessionStorage = false
  ) {
    if (!useSessionStorage) {
      setSessionToken(local_token)
    } else {
      setSessionStorage(local_token)
    }
    setAuthenticated(true)
  }

  function closeSnackbar() {
    setShowError(false)
  }

  if (authenticated) {
    return <Redirect to="/books" />
  }

  return (
    <>
      <Snackbar
        show={showError}
        severity="error"
        handleClose={closeSnackbar}
        autoHideDuration={3000}
      >
        Ocorreu um erro no login.
      </Snackbar>
      <Loading />
    </>
  )
}
